module.exports = __webpack_public_path__ + "static/media/pizza_papito.27b28562.png";